<template>

    <div class="survey_question">
        <div class="survey_label subtitle is-size-4 has-text-grey">{{ label }}</div>

        <div class="survey_radio_response_container">
            <div class="rounded_radio">
                <input v-model="val" type="radio" :id=" questionId + '_score1'" :value="1" @change="updateVal">
                <label class="label" :for="questionId + '_score1'">1</label>
            </div>
            <div class="rounded_radio">
                <input v-model="val" type="radio" :id=" questionId + '_score2'" :value="2" @change="updateVal">
                <label class="label" :for="questionId + '_score2'">2</label>
            </div>
            <div class="rounded_radio">
                <input v-model="val" type="radio" :id=" questionId + '_score3'" :value="3" @change="updateVal">
                <label class="label" :for="questionId + '_score3'">3</label>
            </div>
            <div class="rounded_radio">
                <input v-model="val" type="radio" :id=" questionId + '_score4'" :value="4" @change="updateVal">
                <label class="label" :for="questionId + '_score4'">4</label>
            </div>
            <div class="rounded_radio">
                <input v-model="val" type="radio" :id=" questionId + '_score5'" :value="5" @change="updateVal">
                <label class="label" :for="questionId + '_score5'">5</label>
            </div>
        </div>

    </div>

</template>

<script>
export default {
    name: 'QuestionRadios',
    props: {
        label: {
            required: true,
            type: String
        },
        questionId: {
            required: true,
            type: String
        },
        value: {
            required: true
        }
    },
    components: {},
    data(){
        return {
            val: this.value
        }
    },
    methods: {
        updateVal(event){
            this.$emit('input', parseInt(event.target.value), this.questionId)
        }
    },
}

</script>

<style lang="scss" scoped>
.survey_question{
    margin-bottom: 30px;
    .survey_label{
        font-weight: 300!important;
        margin: 0!important;
    }
    .survey_radio_response_container{
        display: flex;
        justify-content: center;
        align-items: center;
        .rounded_radio{
            user-select: none;

            input{
                opacity: 0;
                height: 1px;
                width: 1px;
            }
            label{
                cursor: pointer;
                background: $grey-lighter;
                height: 52px;
                width: 52px;
                text-align: center;
                margin: 0px 16px;
                border-radius: 100%;
                line-height: 52px;
                font-size: 1.5rem;
                font-weight: 300;
                transition: .3s all;
            }
            input:checked + label{
                box-shadow: inset 0 0 100px $info;
                color: $white;
            }
        }
    }
}
@media screen and (max-width: 1024px) {
    .survey_question{
        .survey_label{
            font-size: 1.25rem!important;
        }
        .survey_radio_response_container{
            .rounded_radio{
                label{
                    margin: 0px 2px;
                }
            }
        }
    }
}
@media screen and (max-width: 649px) {
    .survey_question{
        .survey_label{
            font-size: 1.25rem!important;
        }
        .survey_radio_response_container{
            .rounded_radio{
                label{
                    margin: 0px 2px;
                }
            }
        }
    }
}

</style>